import { render, staticRenderFns } from "./Intersections.vue?vue&type=template&id=a38db95a&scoped=true&"
import script from "./Intersections.vue?vue&type=script&lang=js&"
export * from "./Intersections.vue?vue&type=script&lang=js&"
import style0 from "./Intersections.vue?vue&type=style&index=0&id=a38db95a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38db95a",
  null
  
)

export default component.exports